import { atom } from 'jotai';

export const $CurrentArticleImageDesc = atom<string[]>([]);
